// extracted by mini-css-extract-plugin
export var tosLink = "_ae-0";